var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	85194: () => (loadSingletonVersion("default", "vue", true, [1,3,0,0], () => (() => (__webpack_require__(27827))))),
	88328: () => (loadSingletonVersion("default", "vue", true, [1,3,2,0], () => (() => (__webpack_require__(27827))))),
	822: () => (loadSingletonVersion("default", "vue", true, [4,3,5,13], () => (() => (__webpack_require__(27827))))),
	36897: () => (loadSingletonVersion("default", "vue-i18n", true, [4,10,0,5], () => (() => (__webpack_require__(51005))))),
	39130: () => (loadSingletonVersion("default", "@mcp/frontend-common", false, [0], () => (Promise.all([__webpack_require__.e(6056), __webpack_require__.e(2699), __webpack_require__.e(1563), __webpack_require__.e(6041)]).then(() => (() => (__webpack_require__(6041))))))),
	90703: () => (loadSingletonVersion("default", "vue", true, [,[1,2,6,0],[1,3,0,0,,0],1], () => (() => (__webpack_require__(27827))))),
	29123: () => (loadSingletonVersion("default", "@dsc/federated-styles", false, [0], () => (__webpack_require__.e(4156).then(() => (() => (__webpack_require__(14156))))))),
	22265: () => (loadSingletonVersion("default", "element-plus", false, [4,2,13,7], () => (Promise.all([__webpack_require__.e(1586), __webpack_require__.e(3851)]).then(() => (() => (__webpack_require__(21586))))))),
	37133: () => (loadSingleton("default", "@dsc/federated-styles", false, () => (Promise.all([__webpack_require__.e(4156), __webpack_require__.e(525)]).then(() => (() => (__webpack_require__(14156))))))),
	52699: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/package-big-icon", false, [4,29,3,1], () => (__webpack_require__.e(4888).then(() => (() => (__webpack_require__(14888))))))),
	15435: () => (loadSingletonVersion("default", "vue-router", true, [1,4,5,0], () => (() => (__webpack_require__(9509))))),
	52432: () => (loadSingletonVersion("default", "@design-system/css", false, [4,29,3,1], () => (Promise.all([__webpack_require__.e(8868), __webpack_require__.e(5435)]).then(() => (() => (__webpack_require__(18868))))))),
	94505: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(27827))))),
	98836: () => (loadSingletonVersion("default", "element-plus", false, [1,2,13,7], () => (Promise.all([__webpack_require__.e(1586), __webpack_require__.e(3851)]).then(() => (() => (__webpack_require__(21586))))))),
	52753: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/info-icon", false, [4,29,3,1], () => (__webpack_require__.e(1589).then(() => (() => (__webpack_require__(41589))))))),
	68007: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/time-icon", false, [4,29,3,1], () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(77294))))))),
	92057: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/download-icon", false, [4,29,3,1], () => (__webpack_require__.e(8145).then(() => (() => (__webpack_require__(18145))))))),
	51769: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/conditions-icon", false, [4,29,3,1], () => (__webpack_require__.e(1791).then(() => (() => (__webpack_require__(21791))))))),
	24033: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/bulk-combination-icon", false, [4,29,3,1], () => (__webpack_require__.e(8135).then(() => (() => (__webpack_require__(38135))))))),
	75163: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/location-icon", false, [4,29,3,1], () => (__webpack_require__.e(80).then(() => (() => (__webpack_require__(70080))))))),
	887: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/copy-icon", false, [4,29,3,1], () => (__webpack_require__.e(7722).then(() => (() => (__webpack_require__(87722))))))),
	42578: () => (loadSingletonVersion("default", "vue-i18n", true, [1,10,0,5], () => (() => (__webpack_require__(51005))))),
	52901: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/plus-icon", false, [4,29,3,1], () => (__webpack_require__.e(9081).then(() => (() => (__webpack_require__(99081))))))),
	86419: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/delete-icon", false, [4,29,3,1], () => (__webpack_require__.e(5524).then(() => (() => (__webpack_require__(5524))))))),
	59513: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(8727))))),
	83687: () => (loadSingletonVersion("default", "vue", true, [1,3,5,13], () => (() => (__webpack_require__(78857))))),
	93037: () => (loadSingletonVersion("default", "vue", true, [1,3,3,0], () => (() => (__webpack_require__(27827))))),
	90619: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/paper-pen-icon", false, [4,29,3,1], () => (__webpack_require__.e(4681).then(() => (() => (__webpack_require__(4681))))))),
	66024: () => (loadSingletonVersion("default", "vue-router", true, [4,4,5,0], () => (() => (__webpack_require__(9509))))),
	38295: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/location-building-icon", false, [4,29,3,1], () => (__webpack_require__.e(6343).then(() => (() => (__webpack_require__(16343))))))),
	37993: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/calendar-icon", false, [4,29,3,1], () => (__webpack_require__.e(7595).then(() => (() => (__webpack_require__(97595))))))),
	23602: () => (loadSingletonVersion("default", "@mcp/frontend-shared-domain-components", false, [0], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(1769), __webpack_require__.e(1563), __webpack_require__.e(4747), __webpack_require__.e(223)]).then(() => (() => (__webpack_require__(50223))))))),
	36053: () => (loadSingletonVersion("default", "@dsc/components", false, [0], () => (__webpack_require__.e(5061).then(() => (() => (__webpack_require__(55061))))))),
	81171: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/incidents-icon", false, [4,29,3,1], () => (__webpack_require__.e(6411).then(() => (() => (__webpack_require__(28792))))))),
	38055: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/in-progress-icon", false, [4,29,3,1], () => (__webpack_require__.e(6182).then(() => (() => (__webpack_require__(36182))))))),
	17205: () => (loadSingletonVersion("default", "@design-system/icons/web-components/24x24/search-icon", false, [4,29,3,1], () => (__webpack_require__.e(4325).then(() => (() => (__webpack_require__(14325))))))),
	44079: () => (loadSingletonVersion("default", "@mcp/shared", false, [1,1,94,0], () => (__webpack_require__.e(1118).then(() => (() => (__webpack_require__(20818)))))))
};
var initialConsumes = [85194,88328];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"223": [
		887,
		42578,
		52901,
		86419
	],
	"619": [
		90619
	],
	"822": [
		822
	],
	"1248": [
		81171
	],
	"1563": [
		15435,
		52432,
		94505,
		98836
	],
	"1769": [
		51769
	],
	"2265": [
		22265
	],
	"2699": [
		52699
	],
	"3075": [
		44079
	],
	"3160": [
		90703
	],
	"3851": [
		59513,
		83687,
		93037
	],
	"4360": [
		38055,
		17205
	],
	"4747": [
		24033,
		75163
	],
	"5061": [
		37133
	],
	"6003": [
		23602
	],
	"6041": [
		52753,
		68007,
		92057
	],
	"6053": [
		36053
	],
	"6720": [
		29123
	],
	"6897": [
		36897
	],
	"7418": [
		66024,
		38295,
		37993
	],
	"8792": [
		85194,
		88328
	],
	"9130": [
		39130
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}